const lang = document.documentElement.lang;

export const NAME_LABEL = () => {
  return lang === 'ja' ? '飯塚 修平' : 'Shuhei Iitsuka';
};

export const PROJECTS_LABEL = () => {
  return lang === 'ja' ? 'プロジェクト' : 'Projects';
};

export const WRITINGS_LABEL = () => {
  return lang === 'ja' ? '執筆' : 'Writings';
};

export const ABOUT_LABEL = () => {
  return lang === 'ja' ? '経歴' : 'About';
};

export const BLOG_LABEL = () => {
  return lang === 'ja' ? 'ブログ' : 'Blog';
};

export const BOOKS_LABEL = () => {
  return lang === 'ja' ? '書籍' : 'Books';
};

export const INTL_CONF_LABEL = () => {
  return lang === 'ja' ? '国際会議' : 'International Conference';
};

export const DOMESTIC_JOURNAL_LABEL = () => {
  return lang === 'ja' ? '論文誌' : 'Japan Domestic Journal';
};

export const DOMESTIC_CONF_LABEL = () => {
  return lang === 'ja' ? '国内学会' : 'Japan Domestic Conference';
};

export const MISC_LABEL = () => {
  return lang === 'ja' ? 'その他' : 'Miscellaneous';
};

export const EDUCATION_LABEL = () => {
  return lang === 'ja' ? '学歴' : 'Education';
};

export const WORK_EXPERIENCE_LABEL = () => {
  return lang === 'ja' ? '職歴' : 'Work Experience';
};

export const TALKS_LABEL = () => {
  return lang === 'ja' ? '講演' : 'Talks';
};

export const CONTACTS_LABEL = () => {
  return lang === 'ja' ? '連絡先' : 'Contacts';
};

export const MISSION_STATEMENT = () => {
  const ja = `
    クリエイティブ テクノロジスト / UX エンジニアです。ウェブと機械学習を使って、クリエイティブなアイデアを実現することを仕事にしています。
    `;
  const en = `
    I’m a creative technologist / UX engineer based in Tokyo. I strive to bring innovative ideas into life with web and machine learning technology.
    `;
  return lang === 'ja' ? ja : en;
};
